var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIco16MenuParking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    transform: "translate(-412 -49) translate(412 49) translate(1 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    rx: 7
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    strokeLinejoin: "round",
    strokeWidth: 0.9,
    d: "M7.46 3.55c.989.05 1.553.285 1.989.671.516.457.782 1.06.782 1.814 0 .779-.268 1.376-.776 1.806-.433.367-1.017.584-1.765.623l-.255.007h-.873v2.377H4.55V3.55h2.91zm.011 1.796h-.91V6.68h.887l.058-.001c.232-.009.431-.085.709-.635 0-.207-.052-.38-.181-.506-.136-.134-.329-.187-.563-.19h0z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco16MenuParking);
export default __webpack_public_path__ + "static/media/ico16MenuParking.ae7369e7.svg";
export { ForwardRef as ReactComponent };